export default __webpack_public_path__ + "static/media/3.083b1835.png";